import { MyIcon } from '@web/common-ui';
import { InfoItem } from '../../../../component';

export const ContactDetails = () => {
  const supportMail = process.env['NX_SENDGRID_EMAIL_FROM'];

  return (
    <>
      <InfoItem
        icon={<MyIcon name="phone" />}
        text={
          <a style={{ color: '#3D7F53' }} href="tel:0434950050">
            043 495 00 50
          </a>
        }
      />
      <InfoItem
        icon={<MyIcon name="mail" />}
        text={
          <a style={{ color: '#3D7F53' }} href={`mailto:${supportMail}`}>
            {supportMail}
          </a>
        }
      />
    </>
  );
};
